var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"relative w-full header"},[_c('div',{staticClass:"header-title"}),_c('div',{staticClass:"absolute text-3xl font-bold text-center text-white",style:({
        width: '1200px',
        bottom: '100px',
        left: 'calc(50vw - 600px)',
      })},[_vm._v("\n      "+_vm._s(_vm.info.name)+"\n    ")])]),_c('div',{staticClass:"bg-white"},[_c('div',{staticClass:"max-w-screen-xl pt-4 m-auto"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.info.content)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }